import Text from "shared/components/data-display/text/Text";
import styled from "styled-components";

export const SyncWrapper = styled.div`
    display: inline-flex;
    align-items: center;
`;

export const SyncLabel = styled(Text)`
    padding-left: 3px;
    display: inline-block;
    vertical-align: top;
    padding-top: 4px;
`;

export const SyncIconWrapper = styled.div`
    padding-left: 5px;
    display: inline-block;
    vertical-align: top;
    padding-top: 5px;
`;

export const SyncLoadingWrapper = styled.div`
    padding-left: 5px;
    display: inline-block;
    vertical-align: top;
    padding-top: 2px;
`;
